import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { SeasonsApi } from '@features/seasons/api/seasons.api'
import { SEASONS_FEATURE_TOKEN } from '@features/seasons/tokens/seasons.tokens'
import { seasonsReducer } from '@features/seasons/state/reducers/seasons.reducer'
import { SeasonsEffects } from '@features/seasons/state/effects/seasons.effects'

export function provideSeasons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(SEASONS_FEATURE_TOKEN, seasonsReducer),
    provideEffects([SeasonsEffects]),
    SeasonsApi
  ])
}
